/**
 *
 * @param {string} direction choose direction between "upper" and "lower" to toggle capitalization status
 * @param {string} string the required text for toggling capitalization
 * @returns
 */
export default function toggleCapitalization(direction, string) {
  return (
    (direction === "lower"
      ? string[0].toLocaleLowerCase()
      : string[0].toLocaleUpperCase()) + string.slice(1)
  );
}
